// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetEstimationRentWebRequest,
  TGetEstimationRentWebModel,
  IMappers,
  TGetEstimationRentWebResponse,
  IGetEstimationRentWebResponse,
  IGetEstimationRentWebResponseError,
} from './types';

export const defaultConfig: TGetEstimationRentWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/get-estimation-rent-web/',
  requestType: 'json',
} as TGetEstimationRentWebModel;

export function createGetEstimationRentWebModel(parameters: IGetEstimationRentWebRequest): TGetEstimationRentWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetEstimationRentWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetEstimationRentWebRequest;
}

export async function fetchGetEstimationRentWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetEstimationRentWebOptions<TResponse200, TResponse400>): Promise<
  TGetEstimationRentWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetEstimationRentWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetEstimationRentWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetEstimationRentWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetEstimationRentWebResponse;
}
